import { faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import 'stylesheets/MainAppStyles/TagsInput.css'
const TagsInput = ({ tags, setTags }) => {
    const [tagError, setTagError] = useState(false);
    const deleteTag = (indexToRemove) => {
        setTags(tags.filter((_, index) => index !== indexToRemove))
    }
    const addTags = (e) => {
        if (e.key === " ") {
            e.preventDefault()
            if (e.target.value.length > 0) {
                setTagError(false)
                setTags([...tags, e.target.value]);
                e.target.value = "";
            } else {
                setTagError(true)
                e.target.value = ""
            }
        }
    }

    return (
        <div className='tags-input-container'>
            {/* {tagError && <p className='tag-error'>Tags can not be more than 4</p>} */}
            <div className='tags-input'>
                <ul id='tags'>
                    {
                        tags.map((tag, index) => (
                            <li className='tag' key={index}>
                                <span className='tag-title'>{tag}</span>
                                <i onClick={() => { deleteTag(index) }} className='tag-close-icon'><FontAwesomeIcon icon={faCircleXmark} /></i>
                            </li>
                        ))
                    }
                </ul>
                {tags.length < 3 &&
                    <input type="text" placeholder='Add up to 3 tags' onKeyDown={addTags} />
                }

            </div>
        </div>
    )
}

export default TagsInput